// Non-labour by category — the number and the rate, nothing more. Shared by the claim's Activity
// Map tab (live or frozen via GET /claims/:id/expenditure) and the reviewer portal (frozen
// snapshot.nonLabourBreakdown). Evidence per line stays on the lines inside Edison.
export const NON_LABOUR_CATEGORY_LABEL: Record<string, string> = {
  cloud: 'Cloud',
  llm_tokens: 'LLM tokens',
  software_license: 'Software licences',
  software_subscription: 'Software subscriptions',
  hardware: 'Hardware',
  consultant_fees: 'Consultant fees',
  admin_overhead: 'Admin overhead',
  insurance: 'Insurance',
  company_setup: 'Company setup',
  rdti_claim_prep: 'R&DTI claim preparation',
  other: 'Other',
};
export const categoryLabel = (c: string): string => NON_LABOUR_CATEGORY_LABEL[c] ?? c;

export interface NonLabourCategoryRow { category: string; amount: number; claimableAmount: number; lines?: number }

// Aggregate finer-grained groups (e.g. category × source from a snapshot) into category rows.
export function rollUpNonLabourByCategory(groups: Array<{ category: string; amount: number; claimableAmount?: number; source?: string }>): NonLabourCategoryRow[] {
  const m = new Map<string, { amount: number; claimableAmount: number }>();
  for (const g of groups) {
    const r = m.get(g.category) ?? { amount: 0, claimableAmount: 0 };
    r.amount += g.amount; r.claimableAmount += g.claimableAmount ?? 0; m.set(g.category, r);
  }
  return [...m].map(([category, r]) => ({ category, amount: Math.round(r.amount * 100) / 100, claimableAmount: Math.round(r.claimableAmount * 100) / 100 }))
    .sort((a, b) => b.claimableAmount - a.claimableAmount);
}

export function nonLabourClaimablePercent(rows: NonLabourCategoryRow[]): number | null {
  const spend = rows.reduce((s, r) => s + r.amount, 0);
  return spend > 0 ? Math.round((rows.reduce((s, r) => s + r.claimableAmount, 0) / spend) * 10000) / 100 : null;
}
